import { FormattedMessage } from 'react-intl';

const FormattedMessageWithId = (props) => {
    return <span data-testid="mapPage.error"><FormattedMessage {...props} /></span>;
};

export default FormattedMessageWithId;
